import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { YearselectorComponent } from './yearselector.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [YearselectorComponent],
    imports: [BrowserModule, FormsModule],
    exports: [YearselectorComponent]
})

export class YearselectorModule{ }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/yearselector/yearselector.module.ts